import { Swiper, SwiperSlide } from "swiper/react";
import { Line } from "../../components/Line";
import { Subtitle } from "../../components/Subtitle";
import { Text } from "../../components/Text";
import { SlideBulletNavigation } from "../../../../../components/blog/RelatedPosts/SlideBulletNavigation";
import { useState } from "react";
import { size } from "../../../../../constants";
import "swiper/css";
import { cn } from "../../../../../lib/utils";
import styled from "styled-components";
import { useWindowSize } from "../../../../../hooks/useWindowResize";
import { useTranslation } from "next-i18next";

const SwiperWrapper = styled.div`
  .bullets-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
  }

  .bullet {
    background-color: #FDC41F;
    opacity: 0.5;
  }
  
  .bullet-active {
    opacity: 1;
  }

  :is([data-theme="dark"] &) {
    .bullet {
      background-color: #FDC41F;
    }
  }
`;

function SolutionCard({ solution }) {
	return (
		<div
			className={cn(
				"rounded-lg bg-neutral-06 shadow-solutions",
				[
					"laptop:w-[400px] laptop:h-[614px] laptop:p-6 laptop:mx-0 laptop:mr-auto",
				],
				["p-4 h-[538px] w-[342px] mx-auto"],
			)}
		>
			<img
				className="laptop:w-[352px] laptop:h-[210px] w-full h-[180px]"
				src={solution.image}
				alt=""
			/>
			<h3 className="text-white font-semibold text-xl leading-[32px] laptop:text-2xl laptop:mt-6 laptop:mb-3 mt-4 mb-2">
				{solution.title}
			</h3>
			<p className="text-neutral-03 laptop:text-xl laptop:leading-8 text-lg leading-[30px]">
				{solution.description}
			</p>
		</div>
	);
}

export default function SolutionSection() {
	const { width } = useWindowSize();
	const { t } = useTranslation();
	const isLaptopL = width >= size.laptopL;
	const [activeBullet, setActiveBullet] = useState(0);

	const solutions = [
		{
			title: t("products.grupoAvenida.solution.steps.step1.title"),
			description: t("products.grupoAvenida.solution.steps.step1.description"),
			image: "/landings/assets/images/casos/assets/grupo-avenida/gav-deteccao-automatizada.png",
		},
		{
			title: t("products.grupoAvenida.solution.steps.step2.title"),
			description: t("products.grupoAvenida.solution.steps.step2.description"),
			image: "/landings/assets/images/casos/assets/grupo-avenida/gav-analise-de-risco.png",
		},
		{
			title: t("products.grupoAvenida.solution.steps.step3.title"),
			description: t("products.grupoAvenida.solution.steps.step3.description"),
			image: "/landings/assets/images/casos/assets/grupo-avenida/gav-reativacao-e-governanca.png",
		},
	];

	return (
		<section className="bg-background-02">
			<div className="container-blog">
				<div className="flex flex-col items-center mb-10 laptop:mb-14">
					<Line className="border-[#FDC41F]" />

					<Subtitle>
						<h3>{t("products.grupoAvenida.solution.title")}</h3>
					</Subtitle>

					<Text className="max-w-[342px] laptop:max-w-full mx-auto text-center">
						{t("products.grupoAvenida.solution.description")}
					</Text>
				</div>

				{isLaptopL ? (
					<div className="flex flex-wrap gap-4">
						{solutions.map((solution) => (
							<SolutionCard key={solution.title} solution={solution} />
						))}
					</div>
				) : (
					<SwiperWrapper>
						<Swiper
							slidesPerView={1}
							navigation={false}
							spaceBetween={isLaptopL ? 40 : 24}
							breakpoints={{
								[size.tablet]: {
									slidesPerView: 2,
								},
								[size.laptop]: {
									slidesPerView: 2,
								},
							}}
							onSlideChange={(e) => {
								setActiveBullet(e.activeIndex);
							}}
						>
							{solutions.map((solution) => (
								<SwiperSlide key={solution.title}>
									<SolutionCard solution={solution} />
								</SwiperSlide>
							))}

							<SlideBulletNavigation activeBullet={activeBullet} />
						</Swiper>
					</SwiperWrapper>
				)}
			</div>
		</section>
	);
}
